require('./components/lib/hichina.validator.js');
require('./components/lib/jquery_browser.js');

$(document).ready(function ($) {
  window.contactTemplate = window.contactTemplate || {};
  window.contactTemplate.baseUri = window.contactTemplate.baseUri || 'domain.console.aliyun.com';
  window.contactTemplate.queryUri = window.contactTemplate.queryUri || 'dc.console.aliyun.com';
  window.contactTemplate.list = require('./components/contactList/list');
  window.contactTemplate.form = require('./components/contactForm/form');
  window.creatContactList = window.contactTemplate.list;
  window.creatContactForm = window.contactTemplate.form;
});



// WEBPACK FOOTER //
// ./src/scripts/index.js